export default __webpack_public_path__ + "static/media/0x7fbc10850cae055b27039af31bd258430e714c62.29232cf5.webp";